import { Notification, NOTIFICATION_STYLES } from '../Notification'

function Warning(config) {
  const notificationConfig = {
    ...config,
    style: NOTIFICATION_STYLES.WARNING
  }
  return Notification(notificationConfig)
}

export { Warning, Warning as microbaWarning }
